import styled from 'styled-components';
import { ArrowDownward } from '@material-ui/icons';

const CustomArrowDown = styled(ArrowDownward)`
  &&& {
    margin-left: 0.5rem;
    opacity: 0;
  }
`;

export default CustomArrowDown;
